<script>
	import Button from '../Button/Button.svelte';

	/** @type {String} */
	export let title;
</script>

<div class="links-list">
	<h3 class="title">
		{title}
	</h3>

	<menu>
		<slot LinksListItem={Button} />
	</menu>
</div>

<style>.links-list,menu{gap:.75rem;align-content:start}.links-list{display:inline-grid}.title{font:var(--f-heading-xs-semibold);padding-left:.625rem}menu{display:grid;grid-gap:.75rem;justify-content:start;place-content:start;align-items:start;justify-items:start;place-items:start;padding:0}</style>
